import { adminUsersQueryKeys as e } from "./adminUsersQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { usersApi as n } from "@maat/api-main";
//#region src/users/admin/useAdminUserWorkspacesQuery.ts
var r = (r) => t({
	queryKey: e.workspaces(r),
	queryFn: () => n.adminGetUserWorkspaces(r),
	enabled: !!r
});
//#endregion
export { r as useAdminUserWorkspacesQuery };
